
/* Material */
import Pagination from '@mui/material/Pagination'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import useStyles from './Products.styles'

/* Redux */
import Redux from './Products.Redux'

interface Props {
  page: number
  size: number
  count: number
}

const ProductsPagination: React.FC<Props> = ({ page, size, count }) => {
  const classes = useStyles()
  const { changeFilterPage, changeFilterSize } = Redux()

  const pagesCount = Math.ceil(count / size)

  return <div className={classes.paginationWrapper}>

    <Pagination 
      color='primary' className={classes.pagination}
      page={page} count={pagesCount}
      onChange={(_e,page)=>{
        changeFilterPage(page)
        window.scrollTo(0,106) // TODO: Richtige Herader-Höhe
      }}
    />

    <div className={classes.pageLimit}>
      Zeige {' '}
      <TextField
        select variant='standard'
        value={size}

        onChange={({target:{value}}) => {
          changeFilterSize(Number(value) || size)
        }}
      >

        {[24,48,72,96].map(limit=>
          <MenuItem 
            key={limit}
            value={limit}
          >
            {limit}
          </MenuItem>
        )}

      </TextField>
      {' '} pro Seite
    </div>

  </div>

}

export default ProductsPagination
